export default ( 
    () => {
        
        // LOCAL:
        //return 'http://192.168.86.26:8081';

        // t4g large - NEW INSTANCE - IP: 3.136.5.250, EIP: 3.136.5.250
        //return 'https://ec2-3-136-5-250.us-east-2.compute.amazonaws.com'

        // HTTPS-DOMAIN:
        return 'https://api.vedicastrochart.com';

    }
);